module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/surgicals/logo-42dc5be934b153c0088f2cb5c2ac4c1a.png";